module.exports = __webpack_public_path__ + "static/img/ico_complection.fb3aaca2.png";